export default __webpack_public_path__ + "static/media/multilink-screely.f703d033.png";